import graphQLClient from 'config/graphql-instance';
import { gql } from 'graphql-request';
import { OrderNotesTypes } from '../types';

export type GQLGetOrder = {
  getOrder: {
    notes: OrderNotesTypes[];
  };
};

export const getOrder = async (id: string) => {
  const query = gql`
    query GetOrder($id: ID!) {
      getOrder(_id: $id) {
        notes {
          _id
          content
          created
          critical
          name
          party_id
          resolved
        }
      }
    }
  `;

  const response = await graphQLClient().request<GQLGetOrder>(query, {
    id,
  });

  return response;
};
